<div>
  <div class="sidenav-header">
    <h2>Filter</h2>
    <button mat-icon-button (click)="close()" aria-label="Close Filter">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if (showStylesFilters) {
    <app-style-filters></app-style-filters>
  }
  @if (showEnsembleFilters) {
    <app-ensemble-filters></app-ensemble-filters>
  }
</div>
